export default function getInitState() {
    return {
        logHtmlIsOpen: false,
        logGridIsOpen: true,

        logRowActions: [
            {
                btn_text: '<i class="far fa-folder"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showLog',
            }
        ],
        logHeaderFields: [
            {
                name: "name",
                label: "Fájlnév",
                visibility: true
            },
            {
                name: "path",
                label: "Fájlútvonal",
                visibility: true
            },
            {
                name: "lastModified",
                label: "Módosítva",
                visibility: true,
                slot_name: "created_on_format"
            },
            {
                name: "sizeInKB",
                label: "filesizekb",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
